import { Controller } from '@hotwired/stimulus'

// LRPO-5847 — the Check Errors pop-up spun forever.
//
// This logic used to be an inline <script> inside the turbo-frame that hung the
// fetch off a `turbo:frame-load` listener it registered itself, while the frame
// was still loading. Whether it ever heard the event it was waiting for depended
// on Turbo's ordering between evaluating inline scripts and dispatching that
// event — and when the event had already gone, nothing called the fetch and the
// spinner stayed up.
//
// A Stimulus controller connects when its element enters the DOM, which is
// exactly the moment we want, so there is no event to miss. It also fixes two
// other faults of the inline version: `var handler = null` re-ran on every
// insertion so each open added another window listener, and the URL was baked in
// at render time so a leftover listener fetched the PREVIOUS lead's errors. The
// URL now comes from a value on this element, so every pop-up asks about its own
// lead.
export default class extends Controller {
  static targets = ['body']
  static values  = { url: String }

  connect () {
    this.load()
  }

  load () {
    if (!this.hasBodyTarget || !this.urlValue) return

    fetch(this.urlValue, { headers: { Accept: 'application/json' } })
      .then(response => {
        // ⚠ response.ok is not proof of anything on its own, and a 500 body is
        // usually HTML, so .json() would throw. Fail both the same way.
        if (!response.ok) throw new Error(`HTTP ${response.status}`)
        return response.json()
      })
      .then(data => this.render(data && data.error))
      .catch(() => this.fail())
  }

  render (message) {
    if (message) {
      this.show(message, 'red')
    } else {
      this.show('No Error', 'green')
    }
  }

  fail () {
    this.show('We could not load the errors for this lead. Please try again.', 'red')
  }

  // ⚠ textContent, never innerHTML. This string comes from the server and the
  // old inline version assigned it straight into innerHTML.
  show (message, colour) {
    this.bodyTarget.textContent = message
    this.bodyTarget.style.color = colour
  }
}
